import TextField from '@space-lib/components/form/textField'
import Icon from '@space-lib/components/icon'
import styled from 'styled-components'

export const Container = styled.div`
  min-height: 20.75rem;
`

Container.displayName = 'Container'

export const UsersContainer = styled.div`
  height: 20.75rem;
  overflow: hidden scroll;
  scroll-behavior: smooth;
`

UsersContainer.displayName = 'UsersContainer'

export const CustomTextField = styled(TextField)`
  background-color: var(--background-color) !important;
`

CustomTextField.displayName = 'CustomTextField'

export const CustomIcon = styled(Icon)`
  position: absolute;
  top: 0.825rem;
  right: 1rem;
`

CustomIcon.displayName = 'CustomIcon'
